import React from 'react';
import Typography from '@mui/material/Typography';
import prettyBytes from 'pretty-bytes';

type UploadLimitLabelProps = {
  maxPages?: number;
  maxSize?: number;
  maxSizeLabel?: string;
  limitLabelPrefix?: string;
};

const UploadLimitLabel: React.FC<UploadLimitLabelProps> = ({
  maxPages,
  maxSize,
  maxSizeLabel,
  limitLabelPrefix
}) => {
  const parts: string[] = [];
  if (!!maxPages) {
    parts.push(`${maxPages} pages`);
  }
  if (!!maxSize || !!maxSizeLabel) {
    parts.push(`${maxSizeLabel ?? prettyBytes(maxSize ?? 0)} file size`);
  }
  if (parts.length === 0) {
    return null;
  }
  return (
    <Typography
      variant="subtitle2"
      sx={{ color: 'var(--palette-semantic-text-caption)' }}
      fontWeight={400}
      textAlign="center"
      lineHeight="20px"
    >
      {limitLabelPrefix ?? 'Limit'}: {parts.join(', ')}
    </Typography>
  );
};

export default UploadLimitLabel;
